export default {
    "labels": {
        "labels": "Libellés",
        "publicLabels": "Libellés publics",
        "privateLabels": "Libellés privés",
        "public": "Public",
        "private": "Privé",
        "selectLabel": "Sélectionner le(s) libellé(s)",
        "deleteLabelAreYouSure": "Etes-vous sûr de vouloir effacer le libellé: {name} ?",
        "bulkAddLabelAreYouSure": "Etes-vous sûr de vouloir ajouter en lot le libellé: {name} aux résultats de la requête courante ? ",
        "bulkRemoveLabelAreYouSure": "Etes-vous sûr de vouloir enlever en lot le libellé: {name} aux résultats de la requête courante ?",
        "addPublicLabelText": "+",
        "removePublicLabelText": "×",
        "addPublicLabelTitle": "Ajouter un libellé public",
        "selectPublicLabelTitle": "Sélectionner le libellé public",
        "removePublicLabelTitle": "Supprimer le libellé public",
        "addPrivateLabelText": "+",
        "removePrivateLabelText": "×",
        "addPrivateLabelTitle": "Ajouter un libellé privé",
        "selectPrivateLabelTitle": "Sélectionner le libellé privé",
        "removePrivateLabelTitle": "Supprimer le libellé privé"
    },

    "renameLabel": {
        "title": "Renommer le(s) libellé(s) globalement",
        "btnRename": "Renommer",
        "newLabel": "Nouveau Libellé",
        "oldLabels": "Ancien(s) libellé(s)",
        "alertText": "Cette action renomme le(s) libellé(s) sélectionné(s) dans l'index et est irréversible",
        "successFeedback": "Libellé(s) renommé(s) dans l'index",
        "errorFeedback": "Une erreur s'est produite. Requête non aboutie"
    },

    "deleteLabel": {
        "title": "Supprimer le(s) libellé(s) globalement",
        "btnDelete": "Supprimer",
        "alertText": "Cette action supprime le(s) libellé(s) sélectionné(s) de l'index et est irréversible",
        "successFeedback": "Libellé(s) supprimé(s) de l'index",
        "errorFeedback": "Une erreur s'est produite. Requête non aboutie"
    },

    "bulkRemoveLabel": {
        "title": "Enlever le(s) libellé des résultats courants",
        "btnBulkRemove": "Enlever",
        "alertText": "Cette action enlève le(s) libellé(s) sélectionné(s) de tous les résultats remontés par le moteur (pas seulement de la première page)",
        "successFeedback": "Libellé(s) enlevé(s) de tous les résultats remontés par le moteur",
        "errorFeedback": "Une erreur s'est produite. Requête non aboutie"
    },

    "bulkAddLabel": {
        "title": "Ajouter le(s) libellé(s) aux résultats courants",
        "btnBulkAdd": "Ajouter",
        "alertText": "Cette action ajoute le(s) libellé(s) sélectionné(s) à tous les résultats remontés par le moteur (pas seulement à la première page)",
        "infoText": "Appuyez sur 'Entrée' pour ajouter un nouveau libellé qui n'existe pas dans les suggestions",
        "successFeedback": "Libellé(s) ajouté(s) à tous les résultats remontés par le moteur",
        "errorFeedback": "Une erreur s'est produite. Requête non aboutie"
    },

    "editLabel": {
        "title": "Editer le(s) libellé(s) de(s) résultat(s) sélectionné(s)",
        "btnEdit": "Sauvegarder",
        "alertText": "Cette action édite le(s) libellé(s) de(s) résultat(s) sélectionné(s)",
        "infoText": "Appuyez sur 'Entrée' pour ajouter un nouveau libellé qui n'existe pas dans les suggestions",
        "labelsToBeRemoved": "Libellé(s) à enlever",
        "labelsToBeAdded": "Libellé(s) à ajouter",
        "successFeedback": "Libellé(s) de(s) résultat(s) sélectionné(s) édité(s)",
        "errorFeedback": "Une erreur s'est produite. Requête non aboutie"
    }
};
